<div class="p-3 content" style="border-radius: 4px; margin-right: -32px;">
    <div class="d-flex">
        <span>
            <img class="rounded-circle" *ngIf="data?.groupImageUrl" [src]="data.groupImageUrl" />
        </span>
        <span cvLocalizedText langSection="Manual_Awards_Context_Menu" langKey="Give_Header"
            class="font-size-16 font-weight-bold ml-3 mt-3">
            Give an award to:
        </span>
        <span class="font-size-16 font-weight-bold ml-2 mt-3">{{ selectedRow.groupName }}</span>
        <!-- Close button -->
        <div class="position-absolute" style="top: 8px; right: 8px;">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="close()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
        </div>
    </div>
    <hr />

    <div *ngIf="isLoadingAwards">
        <cv-loader [size]="'large'" [overlay]="false"></cv-loader>
    </div>

    <div class="overflow-auto" style="height: 75vh;">
        <div class="search-box live-search w-25 ml-auto mr-5 mt-4">
            <input type="search" class="form-control" cvLocalizedPlaceholder langSection="Manual_Awards_Context_Menu" langKey="Search" placeholder="Search" [(ngModel)]="searchTerm"
                (ngModelChange)="changeSearchTerm(searchTerm)" />
            <span class="clear-input" *ngIf="searchTerm.length > 0"
                (click)="searchTerm = ''; changeSearchTerm(searchTerm)"></span>
        </div>

        <div class="d-flex align-items-center justify-content-center text-center color-valyrianSteel"
            style="height: 50vh;" *ngIf="!isLoadingAwards && showNoElementsMsg()">
            <span  langSection="Manual_Awards_Context_Menu" langKey="No_Results_Found">No results found</span>
        </div>

        <div class="my-4" *ngIf="!isLoadingAwards">
            <div *ngFor="let folder of data.folderedAwards; let folderIndex = index">
                <div class="accordion" *ngIf="!status.hidden[folderIndex]">
                    <ngb-accordion [activeIds]="activePanelIds" (activeIdChange)="onPanelChange($event)">
                        <ngb-panel [id]="'panel' + folderIndex">
                            <ng-template ngbPanelTitle>
                                <span class="color-whaleTail font-size-16">{{ folder.Key }}</span>
                                <button type="button" *ngIf="!status.open.includes('panel' + folderIndex)"
                                    class="icon-btn fill-theUpsideDown locked-product-arrows">
                                    <svg class="icon-16">
                                        <use href="../../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use>
                                    </svg>
                                </button>
                                <button type="button" *ngIf="status.open.includes('panel' + folderIndex)"
                                    class="icon-btn fill-theUpsideDown locked-product-arrows">
                                    <svg class="icon-16">
                                        <use href="../../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use>
                                    </svg>
                                </button>
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div *ngFor="let award of (folder.Value | awardsFilter: searchTerm); let awardIndex = index">
                                    <cv-award-card
                                        [imageUrl]="'../admin/imageResizer.aspx?imgid=' + award.badgeImageID + '&w=64&h=64'"
                                        [awardName]="award.rule.RuleName"
                                        [awardDescription]="award.rule.RuleDescription"
                                        [coinAmount]="award.coinAmount"
                                        [xpQuantity]="award.xpQuantity"
                                        [awardPeriod]="award.awardPeriod"
                                        [isUnlimited]="award.isUnlimited"
                                        [awardLimit]="award.awardLimit"
                                        [awardCount]="award.awardsCount"
                                        [updateSuccess]="award.updateSuccess"
                                        (giveAwardClick)="confirmGiveAward(award)"
                                        [isGivingAward]="award.isGiving">
                                    </cv-award-card>
                                </div>
                            </ng-template>
                        </ngb-panel>
                    </ngb-accordion>
                </div>
            </div>
        </div>    
    </div>
</div>